var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.extLink)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.to,"target":"_blank"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }